import React, { useState, useEffect, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
export const InviteModal = ({
  open,
  onClose,
  inviteEmail,
  setInviteEmail,
  onSubmit,
}) => {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const onBackdrop = (e) => {
    if (panelRef.current && !panelRef.current.contains(e.target)) onClose?.();
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onMouseDown={onBackdrop}
      aria-modal="true"
      role="dialog"
    >
      <div
        ref={panelRef}
        className="bg-white rounded-2xl p-6 w-[420px] max-w-[calc(100%-32px)] shadow-xl border border-gray-100"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-medium mb-4">참여자 초대</h3>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            이메일 주소
          </label>
          <input
            type="email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="user@example.com"
            autoFocus
          />
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
          >
            취소
          </button>
          <button
            onClick={onSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            초대하기
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default InviteModal;
